import { BaseEnum } from "./base";
import { Ship } from "./product";

export interface UpgradePlan {
  typeId: number | null;
  positions: string[];
  fileId: number | null;
}

/** 层级序号输入框状态（三级/二级/一级通用，按层级作单值或多值输入） */
export interface LvInputState {
  val: string; // 单值模式值（作为下级框的固定上级编号）
  list: string[]; // 多值模式编号标签
  input: string; // 多值模式输入临时值
  error: boolean; // 格式错误红框
}

// Svc004 新协议：每行一个设备
export interface Svc004DevicePlan {
  devType?: string; // 设备类型（前端 UI 用，提交时不传给后端）
  devName: string; // 设备名称
  subType: number | null; // 1:BCU 2:BSMU 3:BAMU 4:ITMU 5:ITPU 6:EMU
  subName: string; // 子设备名称
  subInfo: string; // 页面展示用：子设备名称-子设备类型，如 "BSMU-2"
  subLv: number | null; // 子设备层级：3=三级 2=二级 1=一级
  subInfoError: boolean; // 格式错误时输入框显示红色
  lv3: LvInputState; // 三级序号框（层级3=多值；层级2/1=固定单值）
  lv2: LvInputState; // 二级序号框（层级2=多值；层级1=固定单值；层级3 隐藏）
  lv1: LvInputState; // 一级序号框（层级1=多值；其他隐藏）
  fileUid: number | null; // 关联上传文件的 uid
}

// 子设备类型映射
export const SUB_TYPE_MAP: Record<number, string> = {
  1: "BCU",
  2: "BSMU",
  3: "BAMU",
  4: "ITMU",
  5: "ITPU",
  6: "EMU",
};

export interface DeviceUpgradePlan {
  id: string;
  planName: string;
  ship: Ship;
  endpointId: string;
  status: BaseEnum;
  customerAttitude: number;
  planTime: Date;
  totalItems: number;
  completedItems: number;
  successItems: number;
  failItems: number;
  createtime: Date;
  updatetime: Date;
}

// Svc004 升级项（展开行）
export interface Svc004UpgradeItem {
  id: string;
  sequence: number;
  devType: string;
  devName: string;
  subName: string;
  subType: number;
  subId: string[];
  fileName: string;
  status: BaseEnum;
  pushTime: Date;
  responseTime: Date;
  resultTime: Date;
  createtime: Date;
  updatetime: Date;
}

export interface EndpointUpgradePlan {
  id: string;
  ship: Ship;
  planTime: Date;
  endpointId: string;
  updatetime: Date;
  createtime: Date;
  attitude: BaseEnum;
  status: BaseEnum;
  fileName: string;
}
